import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

import { computed } from 'vue'
import { TournamentTypeToName, TOURNAMENT_TYPE } from '@/model/TournamentType'
import CBeloteHeader from '@/components/headers/CBeloteHeader.vue'
import CRommeHeader from '@/components/headers/CRommeHeader.vue'
import CRommeMastersHeader from '@/components/headers/CRommeMastersHeader.vue'
import CSkatHeader from '@/components/headers/CSkatHeader.vue'
import CSkatMastersHeader from '@/components/headers/CSkatMastersHeader.vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'CTournamentHeader',
  props: {
    zone: { default: '' },
    language: { default: 'en' }
  },
  setup(__props: any) {

const props = __props
const zoneTrimmed = computed(() => {
  return props.zone.replace('_gd', '')
})

return (_ctx: any,_cache: any) => {
  const _component_t_header = _resolveComponent("t-header")!

  return (_openBlock(), _createBlock(_component_t_header, { class: "tournaments-page-header" }, {
    default: _withCtx(() => [
      (zoneTrimmed.value === _unref(TournamentTypeToName)[_unref(TOURNAMENT_TYPE).BEL_TOURNAMENT])
        ? (_openBlock(), _createBlock(CBeloteHeader, { key: 0 }))
        : _createCommentVNode("", true),
      (zoneTrimmed.value === _unref(TournamentTypeToName)[_unref(TOURNAMENT_TYPE).ROM_TOURNAMENT])
        ? (_openBlock(), _createBlock(CRommeHeader, {
            key: 1,
            language: _ctx.language
          }, null, 8, ["language"]))
        : _createCommentVNode("", true),
      (zoneTrimmed.value === _unref(TournamentTypeToName)[_unref(TOURNAMENT_TYPE).ROM_MASTERS])
        ? (_openBlock(), _createBlock(CRommeMastersHeader, { key: 2 }))
        : _createCommentVNode("", true),
      (zoneTrimmed.value === _unref(TournamentTypeToName)[_unref(TOURNAMENT_TYPE).SKA_TOURNAMENT])
        ? (_openBlock(), _createBlock(CSkatHeader, { key: 3 }))
        : _createCommentVNode("", true),
      (zoneTrimmed.value === _unref(TournamentTypeToName)[_unref(TOURNAMENT_TYPE).SKA_MASTERS])
        ? (_openBlock(), _createBlock(CSkatMastersHeader, { key: 4 }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})